<div class="container-inboxManagement">
    <figure>
        <!-- <img src="" alt="Bandeja de entrada y gestión imagen"> -->
    </figure>
    <h3>Bandeja de entrada y gestión</h3>
    <button *ngIf="rol === 'AdminFuncional' || 'AdminTI'" class="secondaryButton" (click)="viweBadejaFuncionario()"> Consulte la lista de los trámites
        que debe procesar</button>
</div>